import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from 'react';
export function useSegmentationState(initialState) {
  var _useState = useState(initialState),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var updateState = function updateState(updates) {
    setState(function (prev) {
      return _objectSpread(_objectSpread({}, prev), updates);
    });
  };
  var updateValue = function updateValue(updates) {
    setState(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        value: _objectSpread(_objectSpread({}, prev.value), updates)
      });
    });
  };
  var handleClear = function handleClear() {
    updateState({
      fieldId: undefined,
      conditionalType: undefined,
      value: {
        selected: [],
        input: undefined,
        date: undefined
      }
    });
  };
  return {
    state: state,
    updateState: updateState,
    updateValue: updateValue,
    handleClear: handleClear
  };
}